import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LabelS } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

import { SearchTableHeader } from 'components/searchPlayerTable/SearchTableHeader';
import { StatsCell } from 'components/searchPlayerTable/SearchTableHeader/ui';

const StartStatsCell = styled(StatsCell)`
  justify-content: flex-start;
`;

export const CompletedTransactionsListHeader = () => {
  return (
    <SearchTableHeader>
      <StartStatsCell>
        <LabelS>
          <FormattedMessage {...glossary.date} />
        </LabelS>
      </StartStatsCell>
      <StartStatsCell>
        <LabelS>
          <FormattedMessage
            id="Player.CompletedTransactions.listHeader.type"
            defaultMessage="Type"
          />
        </LabelS>
      </StartStatsCell>
      <StartStatsCell>
        <LabelS>
          <FormattedMessage
            id="User.CompletedTransactions.received"
            defaultMessage="Received"
          />
        </LabelS>
      </StartStatsCell>
      <StartStatsCell>
        <LabelS>
          <FormattedMessage
            id="User.CompletedTransactions.listHeader.from"
            defaultMessage="From"
          />
        </LabelS>
      </StartStatsCell>
      <StartStatsCell>
        <LabelS>
          <FormattedMessage
            id="User.CompletedTransactions.sent"
            defaultMessage="Sent"
          />
        </LabelS>
      </StartStatsCell>
    </SearchTableHeader>
  );
};
